export const AmountPrintingPolicy = ({

    NORMAL : "Normal",
    IN_XXX : "In XXX",
    TOTAL_AMOUNT_ONLY : "Total Amount Only",    
})
